export default function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/shared/effect-target.js
// module id = 131
// module chunks = 9